import { useEffect, useState } from "react";
import { Link, useNavigate, useHref } from "react-router-dom";

import { styled } from '@mui/material/styles';
import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Rating from '@mui/material/Rating';
import Typography from '@mui/material/Typography';
import Switch from '@mui/material/Switch';
import Container from '@mui/material/Container';
import Alert from '@mui/material/Alert';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import CircularProgress from '@mui/material/CircularProgress';
import useMediaQuery from '@mui/material/useMediaQuery';
import Tooltip from '@mui/material/Tooltip';

import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';

import * as React from 'react';
import Collapse from '@mui/material/Collapse';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import { red } from '@mui/material/colors';
import FavoriteIcon from '@mui/icons-material/Favorite';
import ShareIcon from '@mui/icons-material/Share';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import AddBoxTwoToneIcon from '@mui/icons-material/AddBoxTwoTone';

const config = require("./../../constants/constants.js")

const ExpandMore = styled((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme }) => ({
  marginLeft: 'auto',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  }),
  variants: [
    {
      props: ({ expand }) => !expand,
      style: {
        transform: 'rotate(0deg)',
      },
    },
    {
      props: ({ expand }) => !!expand,
      style: {
        transform: 'rotate(180deg)',
      },
    },
  ],
}));


const AppointmentCardComponent = ({ appointmentItem, idx, setShowDetailAppointmentNumber, setShowInfoEventSection, dailyAppointments,
  setHourStartBooking, setHourStartBookingString, setDurataScelta, setCategory, setEvent, setProdottoScelto, setTitleAppointment, setDescriptionAppointment, setNoteAppointment, 
  setClienteDigitato, setRisorsaScelta, setSitoScelto, getEventsApiRequest, setEventsList
 }) => {

  let navigate = useNavigate();

  const widthCard = 390;

  const [expanded, setExpanded] = React.useState(false);
  const [start, setStart] = React.useState({});
  const [end, setEnd] = React.useState({});


  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  console.log("[AppointmentCardComponent] appointmentItem =", appointmentItem);
  console.log("[AppointmentCardComponent] idx =", idx);
  console.log("[AppointmentCardComponent] appointmentItem.name =", appointmentItem.name);
  console.log("[AppointmentCardComponent] start =", appointmentItem.start);

  useEffect(() => {
    if (!appointmentItem || !appointmentItem.start) {
      setStart('00:00');
    }
    else setStart(appointmentItem.start);
    console.log("[CreateEventElementCard useEffect] appointmentItem.start=", appointmentItem.start)
    if (!appointmentItem || !appointmentItem.end) {
      setEnd('00:00');
    }
    else setEnd(appointmentItem.end);
    console.log("[CreateEventElementCard useEffect] appointmentItem.end=", appointmentItem.end)
    //console.log("[CreateEventElementCard useEffect] appointmentItem.start=",appointmentItem.start.hourString)
    //console.log("[CreateEventElementCard useEffect] pageAll=",subTitleImage)
  }, [setStart, setEnd])

  const EspandiInfoAppuntamento = (appointmentItem, idx) => {
    console.log('[EspandiInfoAppuntamento] idx =',idx);
    console.log('[EspandiInfoAppuntamento] appointmentItem =',appointmentItem);
    console.log('[EspandiInfoAppuntamento] appointmentItem.durationMins =',appointmentItem.durationMins);
    console.log('[EspandiInfoAppuntamento] appointmentItem.category =',appointmentItem.eventtype);
    console.log('[EspandiInfoAppuntamento] appointmentItem.event =',appointmentItem.event);
    console.log('[EspandiInfoAppuntamento] appointmentItem.customer =',appointmentItem.customer);
    
    // aggiorno var per Panel dettagli app.
    //setHourStartBooking(appointmentItem.start.hourString);
    setHourStartBookingString(appointmentItem.start.hourString);
    //setName(appointmentItem.name);
    setDurataScelta(appointmentItem.durationMins);
    setCategory(appointmentItem.eventtype);
    setEvent(appointmentItem.event);
    setProdottoScelto(appointmentItem.event);
    setTitleAppointment(appointmentItem.name);
    setDescriptionAppointment(appointmentItem.description)
    setNoteAppointment(appointmentItem.note);
    setClienteDigitato(appointmentItem.customer);
    setRisorsaScelta(appointmentItem.resource);
    setSitoScelto(appointmentItem.site);

   getEventsApiRequest(appointmentItem.eventtype, "", "", "", "")
      .then((productItems) => {
        setEventsList(productItems.events);
        console.log('combo =', appointmentItem.eventtype);
        //console.log('categoriaScelta=',categoriaScelta); 
        console.log('productItems=', productItems);
      })
      .catch((er) => {
        console.log(er);
      });    
 /*
        "name": titleAppointment,
        "description": descriptionAppointment,
        "note": noteAppointment,
        "event": prodottoScelto,
        "eventtype": categoriaScelta,
        "resource": risorsaScelta,
        "site": sitoScelto,
        "durationMins": durataScelta,
        "customer": clienteDigitato,
        "start": startDate,
        "end": endDate,
 */

    setShowDetailAppointmentNumber(idx);
    setShowInfoEventSection("Si");
  };

  return (

    <Card
      sx={{
        width: widthCard,
        minWidth: widthCard,
        borderColor: '#0c2b85',
        border: 0,
        margin: 0,
        paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
        backgroundColor: '#ffffff',
        '&:hover': {
          backgroundColor: '#e9e9e9',
          opacity: [0.9, 0.8, 0.7],
        },
      }}
    >

      <CardContent
        sx={{
          width: widthCard
        }}
      >

        <Box
          sx={{
            width: widthCard,
            maxHeight: { xs: widthCard, md: widthCard },
            maxWidth: { xs: widthCard, md: widthCard },
          }}
          onClick={() => {
            EspandiInfoAppuntamento(appointmentItem, idx)
          }}
        >

          <Grid container
            spacing={0}
            sx={{
              paddingLeft: 0, paddingRight: 1, paddingTop: 0, paddingBottom: 0,
              flexDirection: { xs: "row", md: "row" }
            }}
          >

            <Grid size={{ xs: 6, md: 6 }}>

              <Typography
                sx={{
                  fontFamily: 'Arial',
                  fontWeight: 500,
                  fontSize: 12,
                  color: 'rgb(11, 11, 11)'
                }}
              >
                inizio {start.hourString}
              </Typography>
              <Typography
                sx={{
                  fontFamily: 'Arial',
                  fontWeight: 500,
                  fontSize: 12,
                  color: 'rgb(24, 24, 175)'
                }}
              >
                titolo: {appointmentItem.name}
              </Typography>
              <Typography
                sx={{
                  fontFamily: 'Arial',
                  fontWeight: 500,
                  fontSize: 12,
                  color: 'rgb(24, 24, 175)'
                }}
              >
                tipo evento: {appointmentItem.eventtype}
              </Typography>
              <Typography
                sx={{
                  fontFamily: 'Arial',
                  fontWeight: 500,
                  fontSize: 12,
                  color: 'rgb(24, 24, 175)'
                }}
              >
                cliente: {appointmentItem.customer}
              </Typography>
              <Typography
                sx={{
                  fontFamily: 'Arial',
                  fontWeight: 500,
                  fontSize: 12,
                  color: 'rgb(24, 24, 175)'
                }}
              >
                risorsa: {appointmentItem.resource}
              </Typography>
              <Typography
                sx={{
                  fontFamily: 'Arial',
                  fontWeight: 500,
                  fontSize: 12,
                  color: 'rgb(24, 24, 175)'
                }}
              >
                durata {appointmentItem.durationMins}
              </Typography>

            </Grid>

            <Grid size={{ xs: 6, md: 6 }}>

              <Typography
                sx={{
                  fontFamily: 'Arial',
                  fontWeight: 500,
                  fontSize: 12,
                  color: 'rgb(11, 11, 11)'
                }}
              >
                fine {end.hourString}
              </Typography>
              <Typography
                sx={{
                  fontFamily: 'Arial',
                  fontWeight: 200,
                  fontSize: 12,
                  color: 'rgb(24, 24, 175)'
                }}
              >
                descrizione: {appointmentItem.description}
              </Typography>
              <Typography
                sx={{
                  fontFamily: 'Arial',
                  fontWeight: 200,
                  fontSize: 12,
                  color: 'rgb(24, 24, 175)'
                }}
              >
                note: {appointmentItem.note}
              </Typography>
              <Typography
                sx={{
                  fontFamily: 'Arial',
                  fontWeight: 200,
                  fontSize: 12,
                  color: 'rgb(24, 24, 175)'
                }}
              >
                evento {appointmentItem.event}
              </Typography>
              <Typography
                sx={{
                  fontFamily: 'Arial',
                  fontWeight: 500,
                  fontSize: 12,
                  color: 'rgb(24, 24, 175)'
                }}
              >
                luogo: {appointmentItem.site}
              </Typography>

            </Grid>

          </Grid>

        </Box>

      </CardContent>

    </Card>

  );
};

export default AppointmentCardComponent;
